var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lock-screen-btn-con",on:{"click":_vm.lockScreen}},[_c('Tooltip',{attrs:{"content":"锁屏","placement":"bottom"}},[_c('Icon',{attrs:{"type":"md-lock","size":23}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21cd1f62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-components/lockscreen/lockscreen.vue
// module id = null
// module chunks = 